import { createFileRoute, notFound } from '@tanstack/react-router';

import { billingSettingListSearch } from '@/modules/billing-setting/public';
import { lazyScreen } from '@/shared/screen';

// Régua de cobrança só em dev: a tela real sobre o MSW (`@/modules/billing-setting/testing`, X02).
// Em produção a rota responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/regua-cobranca')({
  validateSearch: billingSettingListSearch,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('@/modules/billing-setting/testing'), 'BillingSettingDevPage') : () => null,
});
